
import Vue from "vue";
import { Sale } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";

export default Vue.extend({
	data() {
		return {
			fromProduct: true,
			ledgerAccountCode: "",
			isSubmitting: false,
		};
	},
	props: {
		sales: {
			type: Array as () => Sale[],
			required: true,
		},
	},
	computed: {
		isValid():boolean {
			if (this.fromProduct) return true;
			return this.ledgerAccountCode != "";
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async submit() {
			if (this.isSubmitting) return;
			if (!this.isValid) return;
			this.isSubmitting = true;
			try {
				await SaleService.fillLedgerAccounts(this.sales, {
					fromProduct: this.fromProduct,
					ledgerAccountCode: this.ledgerAccountCode,
				});
				this.$wf.notify(this.$ct("started"), "info", 3000, "info-circle");
				this.$emit("refresh");
				this.close();
			} finally {
				this.isSubmitting = false;
			}
		},
	},
	components: {
		AppLedgerAccountAutocomplete,
	},
	i18nEx: {
		componentPrefix: "components.sales.FillLedgerAccountsModal",
	},
});
